import { sortConfig } from "./sortConfig";

export const mapStateSortToDisplay = ({
  sort: stateSort,
  sortOrder: stateSortOrder
}) => {
  const { value: displaySort } = sortConfig.find(
    ({ sort, sortOrder }) => stateSort === sort && stateSortOrder === sortOrder
  );

  return displaySort;
};
